import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useRevenueBySegments(id) {
  const { data, error, isLoading } = useSWRImmutable(`/react/revenue/by-segments?stock_id=${id}`, fetcher)

  return {
    revenueBySegments: data,
    isLoading,
    error
  }
}